export default class CustomFormatter {
  constructor (options = {}) {
    this._locale = options.locale || 'en-US'
  }

  interpolate (message, values) {
    if (values.fToC) {
      const fToCel = Math.round((values.temp - 32) * 5 / 9);
      if (values.withPostfix) {
        return [`${fToCel} °C`];
      }
      return [`${fToCel}`];
    }
    const fahrenheitCountries = ['en-US', 'en_BS', 'en-KY', 'en-LR', 'en-PW', 'en-FM', 'en-MH']
    if (fahrenheitCountries.includes(this._locale) || values.cToF) {
      const cToFahr = Math.round(values.temp * 9 / 5 + 32);
      if (values.withPostfix) {
        return [`${cToFahr} °F`];
      }
      return [`${cToFahr}`];
    }
    if (values.withPostfix) {
      return [`${values.temp} °C`];
    }
    return [`${values.temp}`];
  }
}
